module.exports = __webpack_public_path__ + "img/banner-img-new.5351a986.png";